<nav  aria-label="breadcrumb">
  <ol class="breadcrumb mb-2 px-0 py-2">
    <li *ngFor="let breadcrumb of breadcrumbs"  class="breadcrumb-item">
        <a *ngIf="breadcrumb.url" href="#" routerLink="{{breadcrumb.url}}">{{breadcrumb.name }}</a>
        <a *ngIf="!breadcrumb.url">{{breadcrumb.name }}</a>
    </li>     
  </ol>
</nav>